export default __webpack_public_path__ + "static/media/yumble.2ae3989c.gif";